export const ERROR_MESSAGE = 'errorMessage';
export const ERROR_CODE = 'errorCode';
export const CUSTOMER_ID = 'customerId';
export const OPERATION_ID = 'operationId';
export const ORDER_ID = 'orderId';
export const LANDING_PAGE_URL = '/';
export const OPERATIONS_URL = '/operations';